/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2020, Zumper
 * @description  useTrackImpression hook
 */

import type { Listable } from '@zcode/state-type'
import { useEffect, useRef } from 'react'

interface UseTrackImpressionProps {
  entity: Listable
  index: number
  inView: boolean
  onImpression: (args: { entity: Listable; index: number }) => void
}

export const useTrackImpression = ({
  entity,
  index,
  inView,
  onImpression,
}: UseTrackImpressionProps) => {
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>()
  useEffect(() => {
    clearTimeout(timeoutRef.current)
    if (inView) {
      timeoutRef.current = setTimeout(() => {
        onImpression && onImpression({ entity, index })
      }, 500)
    }
    return () => {
      clearTimeout(timeoutRef.current)
    }
  }, [entity, index, inView, onImpression])
}
